import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ActiveHelper from "../../../components/common/activeHelper";
import { firestore, functions } from '../../../helpers/Firebase';
import { accessTypesObject } from "../../../helpers/Utils";
import Admin from "./admin";

const AdminsList = () => {
  const { user } = useSelector(state => state.authUser);
  const search = useSelector(state => state.settings.search) || '';
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [selectedUser, setSelectedUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);


  useEffect(() => {
    firestore().collection('admin').onSnapshot(adminSnap => {
      let data = adminSnap?.docs?.reduce((val, currentVal) => {
        val.push({ ...currentVal.data(), id: currentVal.id, key: currentVal.id })
        return val
      }, [])
      setAdmins(data);
    })
  }, []);

  // Filter admins based on search
  useEffect(() => {
    let adminList = admins || [];

    // Apply search filter
    if (search && search.trim()) {
      const searchLower = search.toLowerCase().trim();
      adminList = adminList.filter(item => {
        return (
          (item?.name?.toLowerCase().includes(searchLower)) ||
          (item?.email?.toLowerCase().includes(searchLower)) ||
          (accessTypesObject?.[item?.role]?.name?.toLowerCase().includes(searchLower))
        );
      });
    }

    setFilteredAdmins(adminList);
  }, [admins, search]);

  // Convert to MainPage tableColumns format
  const tableColumns = useMemo(() => [
    {
      Header: "Name",
      accessor: "name",
      type: 'label'
    },
    {
      Header: "Email",
      accessor: "email",
      type: 'label'
    },
    {
      Header: "Role",
      accessor: "role",
      type: 'label',
      formatValue: (value) => accessTypesObject?.[value]?.name || '--'
    }
  ], []);

  const deleteUserFunc = useCallback(async (user) => {
    const CreateAdmins = functions().httpsCallable('CreateAdmins');
    await CreateAdmins({ displayName: user.name, email: user.email, pw: user.password, role: user.role, type: 'delete', uid: user.key })
    firestore().collection('admin').doc(user.key).delete().then(() => {
      setDeleteUser(false);
      setLoading(false);
    })
  }, []);

  // Custom delete function to handle delete modal
  const handleDelete = useCallback((user) => {
    setDeleteUser(user);
  }, []);

  // Custom edit function to handle edit modal
  const handleEdit = useCallback((user) => {
    setSelectedUser(user || {});
  }, []);

  // Custom create function to handle create modal
  const handleCreate = useCallback(() => {
    setSelectedUser({ addNew: true });
  }, []);


  return (
    <>
      {loading && (
        <div className="loading" />
      )}

      {selectedUser && (
        <Admin
          dismiss={() => setSelectedUser(false)}
          selectedUser={selectedUser}
        />
      )}

      <Modal backdrop="static" isOpen={!!deleteUser}>
        <ModalHeader>
          Delete User
        </ModalHeader>
        <ModalBody>

          <Label className="mb-2">Are you sure you want to delete this user?</Label>

        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setDeleteUser(false)}>Dismiss</Button>
          <Button color='danger' onClick={() => {
            deleteUserFunc(deleteUser);
            setLoading(true);
          }}>Delete</Button>
        </ModalFooter>
      </Modal>

      <ActiveHelper
        title="Users and Permissions"
        selected="admin"
        data={filteredAdmins}
        tableColumns={tableColumns}
        permenatDelete={true}
        defaultSorting="name"
        sortDirection="asc"
        renderAsModal={true}
        modalSize="lg"
        modalBackdrop="static"
        hideDefaultDeleteButton={false}
        customDeleteFunction={handleDelete}
        customDeleteTitle="Delete"
        customEditFunction={handleEdit}
        customEditTitle="Edit"
        customCreateFunction={handleCreate}
        showCreateButton={true}
        user={user}
      />
    </>
  );
};

export default AdminsList;